export const headerQueryKeys = {
  prepareReanalyze: (hashes: string[], skipRlcs: boolean, isUrl: boolean) => [
    "prepareReanalyze",
    ...(hashes ?? []),
    skipRlcs,
    isUrl
  ]
};
